import { Box, Button, Grid, GridItem } from '@flos/react-ui';
import type { WizardPageComponent } from '../../config/wizardPagesConfig';
import WizardPagetemplate from '../../templates/WizardPagetemplate';
import { useRecoilValue } from 'recoil';
import { topConfigContextAtom } from '../../recoil/atoms/topConfigContextAtom';
import { useHippoText } from '../../hooks/useHippoText';
import useWizardNavigation from '../../hooks/useWizardNavigation';
import { jobInfoAtom } from '../../recoil/atoms/jobInfoAtom';

const MitIdLoginPage: WizardPageComponent = () => {
    const { wizardGotoStep } = useWizardNavigation();
    const topConfigContext = useRecoilValue(topConfigContextAtom);
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);
    const getHippoText = useHippoText();
    const redirectUrl = topConfigContext?.loginRedirectUrl ?? '';

    const startLogonPopupWindow = (): void => {
        if (topConfigContext?.loginClient?.startPopup) {
            // TODO: How should the redirect URL look like?
            // If we use implicit url like '/kurv/', then the popup window
            // will by default choose mit.topdanmark.dk as host.
            // So if the customer is using the URL www.topdanmark.dk/kurv/
            // and log in with MitId, then the URL will be mit.topdanmark.dk/kurv/
            // How will this affect the session?
            // The URL below is a suggestion, since the parametre jobId and sessionId is not supported.
            topConfigContext.loginClient.startPopup({
                appName: 'top-online-sales',
                targetUrl: `${redirectUrl}/?onsastep=ShoppingBasketPage&jobId=${jobNumber}&sessionId=${sessionId}`
            });
        }
    };
    return (
        <WizardPagetemplate
            hideNext
            onPrevious={() => {
                wizardGotoStep('ShoppingBasketPage');
            }}
            showGiftCertificateBanner={false}
        >
            <Grid>
                <GridItem span={8} colStart={3}>
                    <Box padding="large" className="u-spacing-stack-l">
                        <Box className="u-bg-supplement-grey-light flos-box--center-children u-shadow-none">
                            <img
                                alt="MitID"
                                src={`${topConfigContext?.resourceUrl ?? ''}/images/mitid.svg`}
                            />
                        </Box>
                        <div className="u-spacing-inset-m--stretch-max">
                            <h4>{getHippoText('DSS-LOGIN-OPTIONS-HEADER')}</h4>
                            <p>{getHippoText('DSS-LOGIN-OPTIONS-SUBHEADER')}</p>
                        </div>
                        <Button
                            minWidth="wider"
                            onClick={() => {
                                startLogonPopupWindow();
                            }}
                        >
                            {getHippoText('DSS-LOGIN-OPTIONS-MITID') + ' MitID'}
                        </Button>
                    </Box>
                </GridItem>
            </Grid>
        </WizardPagetemplate>
    );
};

export default MitIdLoginPage;
